import Pattern from 'react-svg-textures';

// import Axis from './Axis';
// import AxisBottom from './AxisBottom';
// import AxisLeft from './AxisLeft';
// import AxisRight from './AxisRight';
// import AxisTop from './AxisTop';
import LinearGradient from './LinearGradient';

export {
  // Axis,
  // AxisBottom,
  // AxisLeft,
  // AxisRight,
  // AxisTop,
  LinearGradient,
  Pattern,
};



// WEBPACK FOOTER //
// packages/extra/src/index.js